/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientsPatientPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
    changePatientBillingData: boolean;
    changePatientClinicalData: boolean;
}
export const PatientsPatientPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientPermissions_changePatientBillingData_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientPermissions_changePatientClinicalData_Validators: ValidatorFn[] =
    [  Validators.required, ];


